"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactiveVarsCache = exports.makeCachedVar = exports.initReactiveVarsCache = exports.cachedReactiveVarTypename = void 0;
const client_1 = require("@apollo/client");
var rvCache;
exports.cachedReactiveVarTypename = 'CachedReactiveVar';
function initReactiveVarsCache(cache) {
    rvCache = new ReactiveVarsCache({
        cache,
    });
    return rvCache;
}
exports.initReactiveVarsCache = initReactiveVarsCache;
const cachedReactiveVarFragment = (0, client_1.gql) `
  fragment ReadCachedReactiveVarFragment on CachedReactiveVar {
    id
    value
  }
`;
function makeCachedVar(id, value) {
    return rvCache.registerCachedVar(id, value);
}
exports.makeCachedVar = makeCachedVar;
class ReactiveVarsCache {
    constructor({ cache }) {
        this.registeredVars = {};
        this.cache = cache;
    }
    watchReactiveVar(id, rv) {
        rv.onNextChange((value) => {
            this.writeCachedVar(id, value);
            // Reactive variables support an `onNextChange` API that allows listeners
            // to subscribe to the next value change. This only applies to a single change,
            // so to subscribe to every change, a new listener must be added after processing
            // the current change.
            this.watchReactiveVar(id, rv);
        });
    }
    registerCachedVar(id, defaultValue) {
        const cachedValue = this.readCachedVar(id);
        const rv = (0, client_1.makeVar)(cachedValue !== null && cachedValue !== void 0 ? cachedValue : defaultValue);
        if (this.registeredVars[id]) {
            console.warn(`Duplicate cached reactive variable with ID ${id} detected. Multiple cached reactive variables should not share the same ID.`);
        }
        this.registeredVars[id] = {
            rv,
            defaultValue,
        };
        // If the cache did not already had a value for the CachedReactiveVar with this ID,
        // then it should be seeded with one using the provided default value.
        if (!cachedValue) {
            this.writeCachedVar(id, defaultValue);
        }
        this.watchReactiveVar(id, rv);
        return rv;
    }
    readCachedVar(id) {
        var _a;
        const entityId = this.cache.identify({
            __typename: exports.cachedReactiveVarTypename,
            id,
        });
        const cachedData = this.cache.readFragment({
            fragment: cachedReactiveVarFragment,
            id: entityId,
        });
        return (_a = cachedData === null || cachedData === void 0 ? void 0 : cachedData.value) !== null && _a !== void 0 ? _a : null;
    }
    writeCachedVar(id, value) {
        if (value !== undefined) {
            this.cache.writeFragment({
                id: rvCache.cache.identify({
                    __typename: exports.cachedReactiveVarTypename,
                    id,
                }),
                fragment: cachedReactiveVarFragment,
                data: {
                    __typename: exports.cachedReactiveVarTypename,
                    id,
                    value,
                }
            });
        }
    }
    // Notifies all reactive variables that the cache has changed
    // and that they need to be reset to the cache's current value.
    reset() {
        Object.keys(this.registeredVars).forEach((id) => {
            var _a;
            const { rv, defaultValue } = this.registeredVars[id];
            // If the registered reactive variable does not exist in the cache anymore,
            // such as after resetStore() has been called on the cache, then the reactive
            // variable should be reset to its original value.
            rv((_a = this.readCachedVar(id)) !== null && _a !== void 0 ? _a : defaultValue);
        });
    }
}
exports.ReactiveVarsCache = ReactiveVarsCache;
//# sourceMappingURL=ReactiveVarsCache.js.map